import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import useApplicationUid from '../../hooks/useApplicationUid';
import useCustodianTransferTypeDispatch from '../../hooks/useCustodianTransferTypeDispatch';
import useIraApplicationFundingData from '../../hooks/useApplicationIraFundingData';
import { IRA_TRANSFER_TYPES } from '../../util/constants';
import { parseEnumType } from '../../util/helpers/enumMappers';
import Back from '../Buttons/Back';
import { ModalHeading } from '../Modal';
import SelectList from '../SelectList/SelectList';

const CustodianTransferType = ({ handleNext, handleBack }) => {
  const { t } = useTranslation();
  const { ApplicationUid } = useApplicationUid();
  const { custodianTransferTypeDispatch } = useCustodianTransferTypeDispatch();
  const { IraApplicationFundingResponse } = useIraApplicationFundingData();
  const { TransferType } = IraApplicationFundingResponse;

  const onSubmit = (transferType) => {
    custodianTransferTypeDispatch({
      ApplicationUid,
      params: {
        transferType,
      },
      defaultValues: {
        transferType: parseEnumType(IRA_TRANSFER_TYPES, TransferType),
      },
      onSuccess: handleNext,
    });
  };

  const items = [
    {
      title: t('iraCustodian.transfer.fullTransfer'),
      onClick: () => {
        onSubmit('Liquidate');
      },
      selected: parseEnumType(IRA_TRANSFER_TYPES, TransferType) === 'Liquidate',
      dataCy: 'button-full-transfer',
    },
    {
      title: t('iraCustodian.transfer.partial'),
      onClick: () => {
        onSubmit('PartialCash');
      },
      showDivider: false,
      selected:
        parseEnumType(IRA_TRANSFER_TYPES, TransferType) === 'PartialCash',
      dataCy: 'button-partial',
    },
  ];

  return (
    <>
      {handleBack && (
        <Back
          onClick={() => {
            handleBack();
          }}
        />
      )}
      <ModalHeading>{t('iraCustodian.transfer.title')}</ModalHeading>
      <SelectList options={items} />
    </>
  );
};

CustodianTransferType.propTypes = {
  handleNext: PropTypes.func,
  handleBack: PropTypes.func,
};

export default CustodianTransferType;
